import axios from '../axios';

/**
 * AI Chat Management Service
 * For Super Admin and Total roles to manage AI chat access and limits
 */

/**
 * Check AI chat access for a user
 * @param {string} userId - User ID
 * @returns {Promise<Object>} Access information
 */
export const checkAiChatAccess = async (userId) => {
    try {
        const response = await axios.get(`/api/ai-chat-management/access/${userId}`);
        return response.data;
    } catch (error) {
        console.error('Error checking AI chat access:', error);
        throw error;
    }
};

/**
 * Enable/disable AI chat for a user
 * @param {string} userId - User ID
 * @param {boolean} enabled - Enable or disable
 * @returns {Promise<Object>} Updated user information
 */
export const updateAiChatAccess = async (userId, enabled) => {
    try {
        const response = await axios.put(`/api/ai-chat-management/access/${userId}`, { enabled });
        return response.data;
    } catch (error) {
        console.error('Error updating AI chat access:', error);
        throw error;
    }
};

/**
 * Get usage statistics for a user
 * @param {string} userId - User ID
 * @returns {Promise<Object>} Usage statistics
 */
export const getUserUsageStats = async (userId) => {
    try {
        const response = await axios.get(`/api/ai-chat-management/usage/${userId}`);
        return response.data;
    } catch (error) {
        console.error('Error getting usage statistics:', error);
        throw error;
    }
};

/**
 * Set custom prompt limit for a user
 * @param {string} userId - User ID
 * @param {number|null} limit - Custom limit (null to remove custom limit)
 * @returns {Promise<Object>} Updated user information
 */
export const setCustomPromptLimit = async (userId, limit) => {
    try {
        const response = await axios.put(`/api/ai-chat-management/limit/${userId}`, { limit });
        return response.data;
    } catch (error) {
        console.error('Error setting custom limit:', error);
        throw error;
    }
};

/**
 * Get current user's usage statistics
 * @param {string} facilityId - Optional facility ID to include facility usage
 * @returns {Promise<Object>} Current user's usage statistics
 */
export const getMyUsageStats = async (facilityId = null) => {
    try {
        const params = facilityId ? { facilityId } : {};
        const response = await axios.get(`/api/ai-chat-management/my-usage`, { params });
        return response.data;
    } catch (error) {
        console.error('Error getting my usage statistics:', error);
        throw error;
    }
};

